import React, { useCallback, useMemo } from 'react';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { isNotNullable } from 'utils/isNotNullable';
import ReasonsScreenContent, { useBankAccessReasonItem, useReferenceChangeReasonItem, useSyncReasonItem, } from '../components/ReasonsScreenContent';
const strings = {
    title: 'Why are my payments still pending?',
    subtitle: 'There are a few reasons why committed payments you no longer need to pay might still appear',
    renewBankAccessButton: 'Check bank connection status',
    noMatch: 'The new transaction doesn’t match your settings',
    noMatchDescription: 'If the new transaction details don’t match what you’ve set in the recurring payment settings, Emma won’t link it to the recurring payment. ',
    noMatchButton: 'Manage recurring payments',
    inactive: 'Inactive payments are still active',
    inactiveDescription: 'If you’ve stopped paying a merchant, you might need to set the recurring payment as inactive. If you still see payments you’re no longer making, please manage your recurring payments.',
    inactiveButton: 'Manage recurring payments',
};
const PastPendingReasonsScreen = withAnimatedNavigationHeader(({ navigation, onScroll }) => {
    const syncItem = useSyncReasonItem();
    const bankAccessItem = useBankAccessReasonItem(strings.renewBankAccessButton);
    const referenceChangeItem = useReferenceChangeReasonItem();
    const onPressSubscriptions = useCallback(() => {
        navigation.navigateDeprecated('Subscriptions');
    }, [navigation]);
    const items = useMemo(() => [
        syncItem,
        bankAccessItem,
        {
            title: strings.noMatch,
            description: strings.noMatchDescription,
            buttonText: strings.noMatchButton,
            onPress: onPressSubscriptions,
        },
        referenceChangeItem,
        {
            title: strings.inactive,
            description: strings.inactiveDescription,
            buttonText: strings.inactiveButton,
            onPress: onPressSubscriptions,
        },
    ].filter(isNotNullable), [syncItem, bankAccessItem, referenceChangeItem, onPressSubscriptions]);
    return (<ReasonsScreenContent onScroll={onScroll} title={strings.title} subtitle={strings.subtitle} items={items} collapsable/>);
}, () => ({}));
export default PastPendingReasonsScreen;
